import Image from "components/Image";
import { useStoryblokLink } from "hooks";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { ImageAdapterProps } from "./Image.d";

const ImageAdapter = ({
  blok: { src: srcDesktop, srcMobile, alt, height, link, content, credit },
  sbEditable,
}: ReactStoryblokComponent<ImageAdapterProps>) => {
  const resolvedLink = useStoryblokLink(link);
  return (
    <Image
      srcDesktop={srcDesktop}
      srcMobile={srcMobile}
      alt={alt}
      height={height || "initial"}
      link={resolvedLink}
      content={content}
      credit={credit}
      sbEditable={sbEditable}
    />
  );
};
export default ImageAdapter;
